/**
 * Adds UTM parameters to a URL for tracking purposes.
 *
 * @param url The URL to add UTM parameters to
 * @param options UTM parameters to add (all optional)
 * @param options.source The UTM source (e.g., 'brainfish')
 * @param options.medium The UTM medium (e.g., 'popup_widget')
 * @param options.campaign Optional UTM campaign parameter
 * @returns The URL with UTM parameters added
 */
export function addUtmParameters(
  url: string,
  options: {
    source?: string;
    medium?: string;
    campaign?: string;
  },
): string {
  if (!url) {
    return url;
  }

  try {
    const urlObj = new URL(url);

    // Add UTM parameters only if they are provided
    if (options.source && urlObj.searchParams.get('utm_source') === null) {
      urlObj.searchParams.set('utm_source', options.source);
    }
    if (options.medium && urlObj.searchParams.get('utm_medium') === null) {
      urlObj.searchParams.set('utm_medium', options.medium);
    }
    if (options.campaign && urlObj.searchParams.get('utm_campaign') === null) {
      urlObj.searchParams.set('utm_campaign', options.campaign);
    }

    return urlObj.toString();
  } catch {
    // If URL parsing fails, return the original URL
    return url;
  }
}

/**
 * Curried function that adds popup widget-specific UTM parameters to URLs.
 * Uses 'brainfish' as source and 'popup_widget' as medium.
 */
export const addPopupWidgetUtm = (url: string): string =>
  addUtmParameters(url, {
    source: 'brainfish',
    medium: 'popup_widget',
  });
